import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  Container,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  Card,
  CardBody,
  FormGroup,
  FormInput,
  Button,
  Alert,
} from "shards-react";
import { ToastContainer,toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactQuill from "react-quill";

import {
  faCloudArrowDown,
  faPen,
  faMagnifyingGlass,
  faPuzzlePiece,
} from "@fortawesome/free-solid-svg-icons";
import EditorToolbar, { formats } from "shared/utils/reacrQuillToolbar";
import useToken from "shared/hook/useToken";
import baseUrl from "config/baseUrl";
import Bg_Indicators from "shared/assets/img/bg_indicators.png";
import "react-quill/dist/quill.snow.css";

const showNotify = (message , type) => {
  switch(type) {
    case 'success':
      toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case 'error':
      toast.error(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case 'warn':
      toast.warn(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case 'info':
      toast.info(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    default:
      toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
  }
 
};

const axios = require("axios").default;

const StyledContent = styled.div`
  background-image: url(${Bg_Indicators});
  margin-left: -15px;
  margin-right: -15px;
  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: cover;
`;
const StyledContentBody = styled.div`
  background-color: #1968bcab;
  min-height: calc(100vh - 171px);
  margin-left: -15px;
  margin-right: -15px;
`;
const StyledTabContent = styled.div`
  margin-top: 15px;
  background-color: #fff;
  border-radius: 10px !important;
`;
const StyledTabPane = styled.div`
  padding: 20px;
  min-height: calc(100vh - 280px);
  margin-bottom: 50px;
`;
const StyledBreadcrumb = styled(Breadcrumb)`
  .breadcrumb {
    padding: 0 !important;
  }
`;

const StyledCardHeader = styled(CardHeader)`
  background-color: #69737e;
  color: #fff;
`;

const PowerbiDetail = (props) => {
  const { match } = props;
  const { token } = useToken();
  const editorRef = useRef(null);
  const [status, setStatus] = useState(0);
  const [dataindicatorsDataset, setDataindicatorsDataset] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [agencyName, setAgencyName] = useState(null);
  const [agencyUserName, setAgencyUserName] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [indicatorsDatasetId, setIndicatorsDatasetId] = useState(
    match.params.id
  );
  const [importantSource, setImportantSource] = useState(null);
  const [importantSourceEN, setImportantSourceEN] = useState(null);
  const [definition, setDefinition] = useState(null);
  const [definitionEN, setDefinitionEN] = useState(null);
  const [formularCalculate, setFormularCalculate] = useState(null);
  const [formularCalculateEN, setFormularCalculateEN] = useState(null);
  const [link, setLink] = useState(null);
  const [linkEN, setLinkEN] = useState(null);
  const [
    indicatorsDatasetSettingName,
    setIndicatorsDatasetSettingName,
  ] = useState(null);

  const formatDate = (date) => {
    if(date != null){
      const split = date.replace("T"," ").replace(".000Z","").split(" ");
      return `${dayjs(split[0]).format("DD/MM/YYYY")} ${split[1]}`;
    }
    return null;
  };

  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          id: indicatorsDatasetId,
        },
        show: 30,
        page: pageNumber,
        orderBy: "id",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/indicatorsDataset`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setDataindicatorsDataset(response.data);
          setIndicatorsDatasetSettingName(
            response.data.data[0].indicatorsDatasetSettingName
          );
          setAgencyName(response.data.data[0].agencyName);
          setAgencyUserName(response.data.data[0].agencyUserName);
          setImportantSource(response.data.data[0].importantSource);
          setImportantSourceEN(response.data.data[0].importantSourceEN);
          setDefinition(response.data.data[0].definition);
          setDefinitionEN(response.data.data[0].definitionEN);
          setFormularCalculate(response.data.data[0].formularCalculate);
          setFormularCalculateEN(response.data.data[0].formularCalculateEN);
          setLink(response.data.data[0].link);
          setLinkEN(response.data.data[0].linkEN);
          setLastUpdate(response.data.data[0].lastUpdate);
          setFirstName(response.data.data[0].firstName);
          setLastName(response.data.data[0].lastName);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [pageNumber, indicatorsDatasetId]);

  //upload
  const modules = {
    toolbar: {
      handlers: {
        image: imageHandler,
      },
      container: [
        [{ header: "1" }, { header: "2" }, { font: [] }],
        [{ align: [] }],
        [{ size: [] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["link", "image", "video"],
        ["clean"],
      ],
    },
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };

  const saveToServer = (file) => {
    const fd = new FormData();
    fd.append("upload", file);

    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${baseUrl}/v1/setting/indicatorsDataset`, true);
    xhr.onload = () => {
      if (xhr.status === 201) {
        // this is callback data: url
        const url = JSON.parse(xhr.responseText).url;
        insertToEditor(url);
      }
    };
    xhr.send(fd);
  };

  const imageHandler = () => {
    const input = document.createElement("input");

    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      // file type is only image.
      if (/^image\//.test(file.type)) {
        saveToServer(file);
      } else {
        console.warn("You could only upload images.");
      }
    };
  };

  function insertToEditor(url) {
    editorRef.current.getEditor().insertEmbed(null, "image", url);
  }

  const tab = [
    {
      title: "ที่มา/ความสำคัญและความเชื่อมโยง",
      icon: <FontAwesomeIcon icon={faMagnifyingGlass} />,
    },
    {
      title: "คำจำกัดความและความหมาย",
      icon: <FontAwesomeIcon icon={faPen} />,
    },
    {
      title: "โครงสร้างตัวชี้วัด/วิธีการคำนวณ",
      icon: <FontAwesomeIcon icon={faPuzzlePiece} />,
    },
    {
      title: "ลิงค์ Power BI",
      icon: <FontAwesomeIcon icon={faCloudArrowDown} />,
    },
  ];
  const selectTabs = (status) => {
    setStatus(status);
  };
  const onSaveIndicator = () => {
    const sendObject = {
      params: {
        id: indicatorsDatasetId,
      },
      update: {
        link: link,
        linkEN: linkEN,
        importantSource: importantSource,
        importantSourceEN: importantSourceEN,
        definition: definition,
        definitionEN: definitionEN,
        formularCalculate: formularCalculate,
        formularCalculateEN: formularCalculateEN,
      },
    };
    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/updateIndicatorsDataset`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: sendObject,
    };

    axios(config)
      .then((response) => {
        showNotify("แจ้งเตือน! บันทึกข้อมูลเรียบร้อย");
      })
      .catch((error) => {
        console.log(error);
        showNotify(error.message,'error');
      });
  };

  return (
    <>
      <ToastContainer />
      <Container>
        <Row>
          <Col>
            <StyledBreadcrumb>
              <BreadcrumbItem>
                <a href="/administrator/powerbi">{`< กลับ`}</a>
              </BreadcrumbItem>
            </StyledBreadcrumb>
          </Col>
        </Row>
        <Row>
          <Col className="mb-2" md="12">
            <strong>ข้อมูล/ตัวชี้วัด</strong>: {indicatorsDatasetSettingName}
          </Col>
          <Col className="mb-2" md="12">
            <strong>หน่วยงานเจ้าของข้อมูล</strong>: {agencyName}
          </Col>
          <Col className="mb-2" md="5">
            <strong>ผู้อัพเดทข้อมูล</strong>: {firstName} {lastName} ( {agencyUserName} )
          </Col>
          <Col md="5">
            <strong>วันที่อัพเดทข้อมูล</strong>:{" "}
            {formatDate(lastUpdate)}
          </Col>
        </Row>
        <hr style={{ borderColor: "#D0D0D0" }} />
      </Container>
      <StyledContent>
        <StyledContentBody>
          <Container style={{ padding: "20px 0" }}>
            <Row>
              <Col>
                <Nav tabs className="tab-menu">
                  {tab.map((item, key) => (
                    <NavItem key={key}>
                      <NavLink
                        active={status === key ? true : false}
                        onClick={() => selectTabs(key)}
                      >
                        {item.icon}
                        {item.title}
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>
              </Col>
            </Row>
            <Row>
              <Col>
                <StyledTabContent className="tab-content">
                  {status === 0 && (
                    <StyledTabPane>
                      <Card small className="mb-3">
                        <StyledCardHeader>ภาษาไทย</StyledCardHeader>
                        <CardBody>
                          <ReactQuill
                            theme="snow"
                            value={importantSource}
                            onChange={(html) => setImportantSource(html)}
                            modules={modules}
                            formats={formats}
                          />
                        </CardBody>
                      </Card>
                      <Card small className="mb-3">
                        <StyledCardHeader>English</StyledCardHeader>
                        <CardBody>
                          <ReactQuill
                            theme="snow"
                            value={importantSourceEN}
                            onChange={(html) => setImportantSourceEN(html)}
                            modules={modules}
                            formats={formats}
                          />
                        </CardBody>
                      </Card>
                    </StyledTabPane>
                  )}
                  {status === 1 && (
                    <StyledTabPane>
                      <Card small className="mb-3">
                        <StyledCardHeader>ภาษาไทย</StyledCardHeader>
                        <CardBody>
                          <ReactQuill
                            theme="snow"
                            value={definition}
                            onChange={(html) => setDefinition(html)}
                            modules={modules}
                            formats={formats}
                          />
                        </CardBody>
                      </Card>
                      <Card small className="mb-3">
                        <StyledCardHeader>English</StyledCardHeader>
                        <CardBody>
                          <ReactQuill
                            theme="snow"
                            value={definitionEN}
                            onChange={(html) => setDefinitionEN(html)}
                            modules={modules}
                            formats={formats}
                          />
                        </CardBody>
                      </Card>
                    </StyledTabPane>
                  )}
                  {status === 2 && (
                    <StyledTabPane>
                      <Card small className="mb-3">
                        <StyledCardHeader>ภาษาไทย</StyledCardHeader>
                        <CardBody>
                          <ReactQuill
                            theme="snow"
                            value={formularCalculate}
                            onChange={(html) => setFormularCalculate(html)}
                            modules={modules}
                            formats={formats}
                          />
                        </CardBody>
                      </Card>
                      <Card small className="mb-3">
                        <StyledCardHeader>English</StyledCardHeader>
                        <CardBody>
                          <ReactQuill
                            theme="snow"
                            value={formularCalculateEN}
                            onChange={(html) => setFormularCalculateEN(html)}
                            modules={modules}
                            formats={formats}
                          />
                        </CardBody>
                      </Card>
                    </StyledTabPane>
                  )}
                  {status === 3 && (
                    <StyledTabPane>
                      <Card small className="mb-3">
                        <StyledCardHeader>ภาษาไทย</StyledCardHeader>
                        <CardBody>
                          <Row>
                            <Col md="4">
                              <FormGroup>
                                <label>ลิงค์ Power BI</label>
                                <FormInput
                                  placeholder="ลิงค์ Power BI"
                                  onChange={(e) => setLink(e.target.value)}
                                  value={link}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                      <Card small className="mb-3">
                        <StyledCardHeader>English</StyledCardHeader>
                        <CardBody>
                          <Row>
                            <Col md="4">
                              <FormGroup>
                                <label>ลิงค์ Power BI</label>
                                <FormInput
                                  placeholder="ลิงค์ Power BI"
                                  onChange={(e) => setLinkEN(e.target.value)}
                                  value={linkEN}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </StyledTabPane>
                  )}
                </StyledTabContent>
              </Col>
            </Row>
            <Row>
              <Col className="text-right">
                <Button
                  className="btn-success"
                  style={{ minWidth: "260px" }}
                  onClick={onSaveIndicator}
                >
                  บันทึกข้อมูล
                </Button>
              </Col>
            </Row>
          </Container>
        </StyledContentBody>
      </StyledContent>
    </>
  );
};

export default PowerbiDetail;
